const dialog = document.querySelector<HTMLDialogElement>("#image-lightbox");
const dialogImage = dialog?.querySelector<HTMLImageElement>(
  ".image-lightbox-content",
);
const closeButton = dialog?.querySelector<HTMLButtonElement>(
  ".image-lightbox-close",
);
let lockedScrollY = 0;

const lockPageScroll = (): void => {
  lockedScrollY = window.scrollY;
  document.documentElement.classList.add("lightbox-open");
  document.body.classList.add("lightbox-open");
  document.body.style.top = `-${lockedScrollY}px`;
};

const unlockPageScroll = (): void => {
  document.documentElement.classList.remove("lightbox-open");
  document.body.classList.remove("lightbox-open");
  document.body.style.removeProperty("top");
  window.scrollTo(0, lockedScrollY);
};

const closeLightbox = (): void => {
  if (!dialog?.open) return;
  dialog.close();
};

const openLightbox = (sourceImage: HTMLImageElement): void => {
  if (!dialog || !dialogImage) return;

  const source = sourceImage.dataset.lightboxSrc;
  if (!source) return;

  dialogImage.src = source;
  dialogImage.alt = sourceImage.alt;
  lockPageScroll();
  dialog.showModal();
};

document.querySelectorAll<HTMLImageElement>("img[data-lightbox-src]").forEach(
  (image) => {
    image.addEventListener("click", () => openLightbox(image));
    image.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      openLightbox(image);
    });
  },
);

closeButton?.addEventListener("click", closeLightbox);

dialog?.addEventListener("click", (event) => {
  if (event.target === dialog) closeLightbox();
});

dialog?.addEventListener("close", () => {
  unlockPageScroll();
  if (dialogImage) {
    dialogImage.removeAttribute("src");
    dialogImage.alt = "";
  }
});
